module.exports = __webpack_public_path__ + "static/media/07012019002.64647b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/07012019002.png
// module id = 1674
// module chunks = 0